import {Component, computed, inject, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DialogModule, DialogRef} from '@angular/cdk/dialog';
import {ReporteFiltrosComponent} from '../../reporte-filtros.component';
import {ThemeService} from '@/app/core/services/theme/theme.service';

export interface DialogData {
  disableCategories?: boolean;
}

@Component({
  selector: 'app-reporte-filtros-dialog-host',
  standalone: true,
  imports: [CommonModule, DialogModule, ReporteFiltrosComponent],
  templateUrl: './reporte-filtros-dialog.host.html',
  styleUrls: ['./reporte-filtros-dialog.host.scss'],
})
export class ReporteFiltrosDialogHost {
  @ViewChild(ReporteFiltrosComponent) child?: ReporteFiltrosComponent;
  protected reportContent = computed(() => this.themeContent()?.reports);
  protected reportFiltersDialog = computed(() => this.reportContent()?.reportFiltersDialog)
  protected readonly Object = Object;
  private themeService = inject(ThemeService);
  protected themeContent = this.themeService.themeContent;

  constructor(private ref: DialogRef<unknown, DialogData>) {
  }

  get disableCategories(): boolean {
    return this.ref.config.data?.disableCategories ?? false;
  }

  close(): void {
    this.ref.close();
  }

  applyFromHost() {
    if (!this.child?.analysisMode) return;
    const payload = this.child?.getPayload();
    this.ref.close({action: 'apply', ...payload});
  }
}
